import React from 'react'
import {
  SaveButton,
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  FormRow
} from '../../../components'
import { Link } from 'react-router-dom'
import { useViewport, viewportBreakpoint } from '../../../utils'

const Form = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <form>
      <p className="mt-8 xl:mt-0 text-lg mb-5 font-bold font-primary xl:hidden">
        Partner
      </p>
      <FormRow>
        <Label>Name</Label>
        <Input
          className="w-full"
          defaultValue="Maarif Institute"
        />
      </FormRow>
      <FormRow>
        <Label>Website</Label>
        <Input
          className="w-full"
          defaultValue="www.maarifinstitute.com"
        />
      </FormRow>
      <FormRow last>
        <div style={{width: isMobile ? '100%' : '250px'}}>
          <ImagePickerSidebar
            label="Featured Image"
            height="150px"
            buttonWidth={isMobile ? '190px' : '93px'}
            message="JPG, GIF or PNG no larger than 1MB."
          />
        </div>
      </FormRow>
      <div className="flex flex-wrap items-center mb-5 lg:mb-8">
        <div className="w-full lg:w-auto">
          <Link to="/dashboard/profile/partners">
            <SaveButton mobileClassname="mb-5"/>
          </Link>
        </div>
        <div className="w-full lg:w-auto text-center lg:text-left mb-8 lg:mb-0">
          <Link to="/dashboard/profile/partners" className="px-8 text-gray-444 underline text-xs lg:text-sm">Cancel</Link>
        </div>
      </div>
    </form>
  )
}

export { Form }
